export default "__VITE_ASSET__01e2c24b__"